module.exports = __webpack_public_path__ + "img/desert.fcb72ac7.svg";